import React from "react";
import PaperClipWhite from "../../images/paper-clip-white.svg";
import PaperClipRed from "../../images/paper-clip-red.svg";
import DeleteBtn from "../../images/delete.svg";
import { Button, Form } from "react-bootstrap";
import DocumentForm from "./DocumentForm";

const File = ({ files, position, uploadProgress, onUpdate, uploadStarted, failed }) => {
    const handleDocUpdate = (type, val) => {
        onUpdate(prevState => prevState.map((fileData, fileIndex) => {
            if(fileIndex === position) {
                if(type === "source-url") {
                    return {
                        ...fileData,
                        source_url: val
                    };
                } else if(type === "title") {
                    return {
                        ...fileData,
                        title: val
                    };
                }
            }

            return fileData;
        }));
    };

    return (
        <>
            <div className="file tif-mb-40 card overflow-hidden border-0 tif-bg-light-color-papa tif-color-white tif-light-color-november">
                <Form className="secondary-form flex-grow-1">
                    <div className="card-header tif-bg-color-india d-flex align-items-center tif-p-0 border-0">
                        <p className={`filename tif-py-20 tif-px-25 flex-grow-1 ${ uploadProgress === 0 ? "waiting" : "" }${ uploadProgress === 100 && !failed ? "complete" : "" }${ failed ? "failed" : "" }`}>
                            { failed ? <img src={PaperClipRed} className="tif-mr-md-10 tif-mr-5" alt="Paper clip icon" /> : <img src={PaperClipWhite} className="tif-mr-md-10 tif-mr-5" alt="Paper clip icon" /> }
                            { files[position].file.name }
                        </p>
                        {
                            !uploadStarted && !failed && uploadProgress !== 100 &&
                            <Button onClick={() => onUpdate(prevState => prevState.filter((_, fileIndex) => fileIndex !== position))} className="tif-mx-25 flex-shrink-0">
                                <img src={DeleteBtn} alt="Delete icon" />
                            </Button>
                        }
                    </div>
                    <div className="tif-pt-10 tif-pr-70 tif-pb-40 tif-pl-25">
                        <DocumentForm name="drop-file" onChange={ handleDocUpdate } file={ files[position] } position={ position } uploadStarted={ uploadStarted } uploadProgress={ uploadProgress } />
                    </div>
                </Form>
            </div>
        </>
    );
}

export default File;